module.exports = __webpack_public_path__ + "img/user04.a091469f.png";